require('./talk-widget-template.html');
require('./talk-widget.controller');


/*****************
 ** WEBPACK FOOTER
 ** ./app/common/directives/talk-widget/index.js
 ** module id = 180
 ** module chunks = 0
 **/